class CosyURLEncoder {
    private static readonly random = Math.random;

    private static readonly STR_CODING_CHARSET = "4Zak0rQzNsXdVEl3S1CTuf7yJ%tmLHwYqoi6Dh9pjMbG2ePUvBW8gIKx5OFcRnA";
    private static readonly STR_CHARSET_LENGTH = "CodeCharacters-String size does not match the required size";
    private static readonly STR_CHARSET_NULL = "CodeCharacters-String null";

    public static checkCodingCharset(sCodeCharacters: string | null): boolean {
        if (sCodeCharacters === null) return false;

        if (sCodeCharacters.length !== this.STR_CODING_CHARSET.length) return false;

        for (let i = 0; i < this.STR_CODING_CHARSET.length; i++) {
            if (sCodeCharacters.indexOf(this.STR_CODING_CHARSET.charAt(i)) < 0) return false;
        }
        return true;
    }

    public static encode(sURL: string, sCodeCharacters: string, bRandomize: boolean): string {
        const CodeLength = 63;

        if (sCodeCharacters === null) throw new Error(this.STR_CHARSET_NULL);

        if (sCodeCharacters.length !== this.STR_CODING_CHARSET.length) throw new Error(this.STR_CHARSET_LENGTH);

        let i: number;
        let iPos = 17;
        let iStepping = 13;

        let bufExtEsc = "";
        let bufCoded = "";
        let sEncoded: string;

        if (bRandomize) {
            iPos = 17 + Math.floor(this.random() * CodeLength);
            iStepping = 11 + Math.floor(this.random() * CodeLength);
        }

        sEncoded = encodeURIComponent(sURL);
        for (i = 0; i < sEncoded.length; i++) {
            switch (sEncoded.charAt(i)) {
                case "%":
                    bufExtEsc += sEncoded.charAt(i);
                    break;
                case "-":
                    bufExtEsc += "%2D";
                    break;
                case "_":
                    bufExtEsc += "%5F";
                    break;
                case ".":
                    bufExtEsc += "%2E";
                    break;
                case "*":
                    bufExtEsc += "%2A";
                    break;
                default:
                    bufExtEsc += sEncoded.charAt(i);
                    break;
            }
        }

        bufCoded += "COSY-EU-100-";
        bufCoded += iPos;
        bufCoded += iStepping;

        for (i = 0; i < bufExtEsc.length; i++) {
            bufCoded += sCodeCharacters.charAt((iPos + sCodeCharacters.indexOf(bufExtEsc.charAt(i))) % CodeLength);
            iPos += iStepping;
        }

        const strCoded = bufCoded.toString();

        return encodeURIComponent(strCoded);
    }

    public static encodeWithCharset(sURL: string, sCodeCharacters: string): string {
        return this.encode(sURL, sCodeCharacters, true);
    }

    public static encodeDefault(sURL: string): string {
        return this.encode(sURL, this.STR_CODING_CHARSET, true);
    }

    public static decode(sURL: string, sCodeCharacters: string): string {
        const CodeLength = 63;

        let i: number;
        let index: number;
        let iPos: number;
        let iStepping: number;

        if (sCodeCharacters === null) throw new Error(this.STR_CHARSET_NULL);

        if (sCodeCharacters.length !== this.STR_CODING_CHARSET.length) throw new Error(this.STR_CHARSET_LENGTH);

        if (sURL.startsWith("COSY-EU")) {
            let sTempUncoded = "";
            let sTempCoded = decodeURIComponent(sURL);
            let bufDecoded = "";

            const idxUncoded = sTempCoded.indexOf("&&");
            if (idxUncoded >= 0) {
                sTempUncoded = sTempCoded.substring(idxUncoded + 1);
                sTempCoded = sTempCoded.substring(0, idxUncoded);
            }

            if (sTempCoded.length < 16) {
                throw new Error("Illegal header detected");
            }

            iPos = Number.parseInt(sTempCoded.substring(12, 14));
            iStepping = Number.parseInt(sTempCoded.substring(14, 16));

            for (i = 16; i < sTempCoded.length; i++) {
                index = sCodeCharacters.indexOf(sTempCoded.charAt(i)) - iPos;

                if (index < 0) {
                    index -= (Math.floor(index / CodeLength) - 1) * CodeLength;
                }

                bufDecoded += sCodeCharacters.charAt(index % CodeLength);

                iPos += iStepping;
            }

            if (sTempUncoded.length > 0) bufDecoded += sTempUncoded;

            const strDecoded = bufDecoded.toString();

            return decodeURIComponent(strDecoded);
        } else {
            return sURL;
        }
    }

    public static decodeDefault(sURL: string): string {
        return this.decode(sURL, this.STR_CODING_CHARSET);
    }
}
export default CosyURLEncoder;
